export const actionTexts = {
  notLoggedIn: 'Sign in to continue',
  incompleteProfile: 'Complete profile',
  ready: 'Go to checkout',
};

export const getActionText = ({isLoggedIn, user}) => {
  if (!isLoggedIn) return actionTexts.notLoggedIn;
  if (!user?.name) return actionTexts.incompleteProfile;
  return actionTexts.ready;
};

